module.exports = __webpack_public_path__ + "static/media/header-background.06db0a96.jpg";